const AuditTypes = {
  GET_AUDIT_TRAIL_LIST_REQUEST: 'GET_AUDIT_TRAIL_LIST_REQUEST',
  GET_AUDIT_TRAIL_LIST_SUCCESS: 'GET_AUDIT_TRAIL_LIST_SUCCESS',
  GET_AUDIT_TRAIL_LIST_ERROR: 'GET_AUDIT_TRAIL_LIST_ERROR',

  GET_AUDIT_TRAIL_ITEM_REQUEST: 'GET_AUDIT_TRAIL_ITEM_REQUEST',
  GET_AUDIT_TRAIL_ITEM_SUCCESS: 'GET_AUDIT_TRAIL_ITEM_SUCCESS',
  GET_AUDIT_TRAIL_ITEM_ERROR: 'GET_AUDIT_TRAIL_ITEM_ERROR',

  GET_AUDIT_MODULE_REQUEST: 'GET_AUDIT_MODULE_REQUEST',
  GET_AUDIT_MODULE_SUCCESS: 'GET_AUDIT_MODULE_SUCCESS',
  GET_AUDIT_MODULE_ERROR: 'GET_AUDIT_MODULE_ERROR',

  GET_AUDIT_USER_REQUEST: 'GET_AUDIT_USER_REQUEST',
  GET_AUDIT_USER_SUCCESS: 'GET_AUDIT_USER_SUCCESS',
  GET_AUDIT_USER_ERROR: 'GET_AUDIT_USER_ERROR'
};

export default AuditTypes;
